export const USER_SOURCE_HEADER_NAMES = [
  'x-referral-token',
  'x-affiliate-token',
  'x-utm-source',
  'x-utm-medium',
  'x-campaign-id',
  'x-utm-campaign',
  'x-utm-term',
  'x-utm-content',
  'x-fbc',
  'x-gclid',
  'x-ttclid',
  'x-msclkid',
  'x-tblci',
  'x-click-id',
  'x-subid',
  'x-twclid',
  'x-rtci',
] as const;

export type UserSourceHeaderName = (typeof USER_SOURCE_HEADER_NAMES)[number] & string;
export type HeaderMap = Partial<Record<UserSourceHeaderName, string>>;

export const REFERRAL_TOKEN_HEADER = 'x-referral-token' satisfies UserSourceHeaderName;
